import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type TransferBatchFileCountsFragment = { __typename?: 'TransferBatch', fileCounts?: { __typename?: 'FileCounts', canceled?: number | null, failed?: number | null, total?: number | null, uploaded?: number | null, viewable?: number | null } | null };

export const TransferBatchFileCounts = /*#__PURE__*/ gql`
    fragment TransferBatchFileCounts on TransferBatch {
  fileCounts {
    canceled
    failed
    total
    uploaded
    viewable
  }
}
    ` as unknown as DocumentNode<TransferBatchFileCountsFragment, unknown>;

        

        
export const useTransferBatchFileCountsFragment = (
  input: string | Omit<UseFragmentOptions<TransferBatchFileCountsFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'TransferBatch' } };
    return input;
  })();

  return useFragment<TransferBatchFileCountsFragment>({
    fragment: TransferBatchFileCounts,
    fragmentName: 'TransferBatchFileCounts',
    ...options,
  });
};
  
        